module.exports = __webpack_public_path__ + "static/img/print-masterial-bg.548ef4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product-detail/print-masterial-bg.png
// module id = EYgF
// module chunks = 4